import React from 'react';
import { Route, Switch } from "react-router-dom";
import WorkflowReportModule from './workflow-reports-module/workflow-reports-module';
import ReportSubmission from './workflow-reports-module/report-submission/report-submission';
import CertificationOfHoldingsReportModule from './certification-of-holdings-module/certification-of-holdings-module';

const WorkflowReports = () => {
  return (
    <Switch>
      <Route exact path="/tax-exempt-reports">
        <WorkflowReportModule />
      </Route>
      <Route exact path="/certification-of-holdings">
        <CertificationOfHoldingsReportModule />
      </Route>
      <Route exact path="/tax-exempt-reports/application">
        <ReportSubmission />
      </Route>
      <Route exact path="/tax-exempt-reports/application/:applicationId/:isin/:bpId/:reportHash/:interestPaymentDate">
        <ReportSubmission />
      </Route>
    </Switch>
  )
}

export default WorkflowReports;
